export const isProduction = () => process.env.IS_PRODUCTION === 'true';

export const environment = () => {
  if (process.env.NODE_ENV === 'test') {
    return 'test';
  }

  return isProduction() ? 'production' : 'staging';
};
